<template>
     <div class="flex float-left vertical-center">
        <a href @click.prevent="downloadFileConfig">{{ filename }}</a>
    </div>
</template>

<script>
    import Vue from "vue";
    import { url } from "@/configs/apiUrl";
    import axios from 'axios';

    export default Vue.extend({
        name: "DeviceSetupConfigurationFileDownload",
        data() {
            return {
                statusColor: 'primary',
                idFile: null,
                filename: ""
            }
        },
        methods: {
            openLoading() {
                this.$vs.loading({
                    type: 'default',
                })
            },
            downloadFileConfig() {
                this.openLoading()
                let urlFile = url.svd.device_setup.file_download + "/" + this.idFile
                let token = ""
                if (JSON.parse(localStorage.getItem('userInfo')).access_token !== undefined) {
                    token = `Bearer ${JSON.parse(localStorage.getItem('userInfo')).access_token.token}`
                }
                axios({
                    url: urlFile,
                    method: 'GET',
                    headers:{Authorization:token},
                    responseType: 'blob',
                }).then((response) => {
                    this.$vs.loading.close()
                    let url = window.URL.createObjectURL(new Blob([response.data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.filename)
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch(e => {
                    console.log("An error when download file: ", e)
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Alert",
                        text: "File not found",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    })
                })
            }
        },
        mounted() {
            this.idFile = this.params.value
            this.filename = this.params.data.file_name
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .line-0 {
        line-height: 0;
    }
</style>